import React, { DragEvent, useRef, useState } from "react"

import { styled } from "@mui/styles"

import { useTranslations } from "@cirrus/core/i18n/provider"

import { Files } from "../../types/Files"

interface IProps {
  fileCount: number,
  maxAttachments: number,
  setFiles: (files: Files) => void,
}

export const DropArea = ({ fileCount, maxAttachments, setFiles }: IProps) => {
  const inputFile = useRef<HTMLInputElement>(null)
  const [dragEntered, setDragEntered] = useState<boolean>(false)
  const { i18n } = useTranslations()

  const attachmentsLimit = maxAttachments - fileCount
  const attachmentsLimitReached = attachmentsLimit <= 0

  if (attachmentsLimitReached) {
    return (<Wrapper>
      <LimitReached>{i18n("Files:MaximumLimitReached")}</LimitReached>
    </Wrapper>)
  }

  const onDrop = (event: DragEvent<HTMLDivElement>) => {
    onDropLeave(event)
    setFiles(event.dataTransfer?.files || null)
  }

  const onDropLeave = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault()
    event.stopPropagation()
    setDragEntered(false)
  }

  const onDropEnter = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault()
    event.stopPropagation()
    setDragEntered(true)
  }

  return <>
    <input type="file"
           ref={inputFile}
           onChange={(event) => setFiles(event.target.files)}
           style={{ display: "none" }}
           max={attachmentsLimit}
           multiple
           accept={"docx"}/>

    <Wrapper
      className={dragEntered ? "highlighted" : ""}
      onDrop={onDrop}
      onDragLeave={onDropLeave}
      onDragEnter={onDropEnter}
      onDragOver={onDropEnter}>

      {i18n("General:DragFilesHere")} {i18n("General:Or")}
      <Browse
        onClick={() => inputFile.current?.click()}>
        {i18n("General:Browse").toLowerCase()}
      </Browse>
    </Wrapper>
  </>
}

const Wrapper = styled("div")({
  height: "10rem",
  border: ".1rem dashed #79747E",
  borderRadius: ".4rem",
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  gap: ".4rem",

  "&.highlighted": {
    opacity: .5
  }
})

const Browse = styled("a")({
  color: "#0055B0",
  cursor: "pointer"
})

const LimitReached = styled("div")({
  padding: "0 4rem"
})
